import { Theme } from "@material-ui/core";
import createStyles from "@material-ui/core/styles/createStyles";

export const styles = ({ spacing }: Theme) => createStyles({
    container : {
        boxShadow: "0px 1px 5px 0px rgba(0, 0, 0, 0.2)",
        paddingTop: spacing.unit * 1.5,
        paddingBottom: spacing.unit * 1.5,
    },
    logo : {
        marginRight: "auto",
        marginLeft: spacing.unit * 2,
        cursor: "pointer",
        "& img" : {
            width: spacing.unit * 17
        }
    },
    item: {
        textTransform: "uppercase",
        fontWeight: 300,
        marginLeft: spacing.unit,
        marginRight: spacing.unit
    },
    menu: {
        marginTop: spacing.unit * 9.25
    },
    subitem: {
        fontWeight: 300
    },
    linearProgress: {
        height: 2
    }
});


// WEBPACK FOOTER //
// ./src/components/MenuNavBar/MenuNavBar.style.tsx